import { MutationTree } from 'vuex';
import { State } from '@/store/modules/cloud/services/cloud.store';
import { SET_CURRENT_GKE_TAB_MUTATION } from '@/store/modules/cloud/services/cloud.constant';
import { initialState } from '@/store/modules/cloud/services/cloud.store';

const mutations: MutationTree<State> = {
  setCurrentSvc(state: State, data: any) {
    state.cloudSvc = data;
  },
  setCurrentVendor(state: State, data: any) {
    state.cloudVendor = data;
  },
  setCurrentGKECluster(state: State, data: any) {
    state.currentGKECluster = data;
  },
  setCurrentGKENamespace(state: State, data: any) {
    state.currentGKENamespace = data;
  },
  setGKEClusters(state: State, data: any) {
    state.gkeClusters = data;
  },
  setGKENamespaces(state: State, data: any) {
    state.gkeNamespaces = data;
  },
  [SET_CURRENT_GKE_TAB_MUTATION](state: State, data: any) {
    state.currentGkeTab = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
